import {
  applyActionCode,
  confirmPasswordReset,
  verifyPasswordResetCode,
} from "firebase/auth";
import { fAuth } from "../config/firebase";
import { FirebaseError } from "firebase/app";
// ERROR CODES:
// https://firebase.google.com/docs/reference/js/v8/firebase.auth.Auth
// Handle custom
// https://firebase.google.com/docs/auth/custom-email-handler#web-version-9

export async function handleResetPassword({ actionCode, password }) {
  try {
    const email = await verifyPasswordResetCode(fAuth, actionCode);
    // console.log("EMAIL", email, password);
    const resp = await confirmPasswordReset(fAuth, actionCode, password);
    // console.log({ resp });
    return { success: resp };
  } catch (error) {
    return handleError(error);
  }
}

export async function handleVerifyEmail({ actionCode }) {
  try {
    const resp = await applyActionCode(fAuth, actionCode);
    return { success: resp };
  } catch (error) {
    return handleError(error);
  }
}

function handleError(error) {
  if (error instanceof FirebaseError) {
    const errorCode = error.code;
    switch (errorCode) {
      case "auth/expired-action-code":
        return { error: "Your link has been expired" };
      case "auth/invalid-action-code":
        return { error: "Your link is invalid" };
      case "auth/user-disabled":
        return { error: "User is disabled" };
      case "auth/user-not-found":
        return { error: "No user found" };
      case "auth/weak-password":
        return { error: "Your password is weak" };
      // case "":
      //   return { error: "" };
      default:
        return { error: "Something went wrong " + error.message };
    }
  }
  return { error: "Something went wrong " + error };
}
